import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { YearRangeWithPeriodCriteriaFilter } from '../../../generated/model/models';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import {
  InputDateRangeComponentWithDropdown,
  YEAR_DROPDOWN_OPTIONS,
} from '../../Inputs/DateRangeWithDropdown';
import ReadableStatementView from '../../Inputs/ReadableStatementView';
import { allowedYearRange } from '../../Inputs/YearRange/YearRange';

interface Props {
  root?: boolean;
  active: boolean;
  defaultCriteria?: string[]; // default dropdown value, NOT default state
  criteriaOptions?: any[];
  onChange: (values: YearRangeWithPeriodCriteriaFilter) => void;
  defaultAllowedYearRange?: typeof allowedYearRange;
  defaultValue?: YearRangeWithPeriodCriteriaFilter;
}

const YearRangeWithPeriodCriteriaFilterInput: React.FC<Props> = React.memo(
  ({
    defaultCriteria = [YEAR_DROPDOWN_OPTIONS[1].value],
    criteriaOptions = YEAR_DROPDOWN_OPTIONS,
    onChange,
    root,
    active,
    defaultAllowedYearRange = allowedYearRange,
    defaultValue = {
      criteria: defaultCriteria[0] as YearRangeWithPeriodCriteriaFilter.CriteriaEnum,
      value: defaultAllowedYearRange,
    },
  }) => {
    const { t } = useTranslation();
    const [state, setState] = useState<YearRangeWithPeriodCriteriaFilter>(defaultValue);

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onChange, state, root);

    function getCriteria(criteria: YearRangeWithPeriodCriteriaFilter.CriteriaEnum) {
      const label = criteriaOptions.find((c) => c.value === criteria)?.label;

      return label ? t(label) : '';
    }

    const rs: any[] = [];
    if (state.criteria) {
      rs.push({ label: 'Applies for:', value: getCriteria(state.criteria) });
    }
    if (state.value && state.value?.from && state.value?.to) {
      rs.push({
        label: 'Range:',
        value: `From ${state.value.from} to ${state.value.to}`,
      });
    }
    return (
      <>
        {active ? (
          <>
            <InputDateRangeComponentWithDropdown
              active={active}
              defaultOptions={criteriaOptions}
              allowedYearRange={defaultAllowedYearRange}
              defaultState={{ criteria: state.criteria, years: state.value }}
              defaultValue={[state?.criteria as YearRangeWithPeriodCriteriaFilter.CriteriaEnum]}
              onChange={(values) => {
                setState({
                  ...state,
                  criteria: values.criteria,
                  value: values.years!,
                });
              }}
            />
          </>
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

export default YearRangeWithPeriodCriteriaFilterInput;
